module.exports = __webpack_public_path__ + "img/d14.2bc0ab6b.png";